import React from "react";
import PortalModal from "../../Portals";
import { IconButton } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import ErrorOutlinedIcon from "@material-ui/icons/ErrorOutlined";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import {
  ContentModalActiveSurvey,
  CloseModalActiveSurvey,
  TextModalActiveSurvey,
  ButtonActiveSurvey,
  ButtonActiveSurveyCancel,
} from "./MessageYesNo.styled";

const MessageYesNo = ({ message, setResponse, setOpenMessageYesNoModal }) => {
  return (
    <PortalModal>
      <ContentModalActiveSurvey>
        <CloseModalActiveSurvey>
          <Tooltip title="close">
            <IconButton>
              <CloseIcon onClick={() => setOpenMessageYesNoModal(false)} />
            </IconButton>
          </Tooltip>
        </CloseModalActiveSurvey>
        <TextModalActiveSurvey>
          <ErrorOutlinedIcon />
          <p>{message}</p>
        </TextModalActiveSurvey>
        <div style={{ display: "inline-flex", margin: "auto", width: "100%" }}>
          <ButtonActiveSurvey
            onClick={() => {
              setResponse(true);
              setOpenMessageYesNoModal(false);
            }}
          >
            Yes
          </ButtonActiveSurvey>
          <ButtonActiveSurveyCancel
            onClick={() => setOpenMessageYesNoModal(false)}
          >
            No
          </ButtonActiveSurveyCancel>
        </div>
      </ContentModalActiveSurvey>
    </PortalModal>
  );
};

export default MessageYesNo;
